var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderplaced({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 68,
    cy: 68,
    r: 68,
    fill: "#169560"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 68,
    cy: 68,
    r: 50,
    fill: "#169560"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 68,
    r: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 36C76.4869 36 84.6263 39.3714 90.6274 45.3726C96.6286 51.3737 100 59.5131 100 68C100 76.4869 96.6286 84.6263 90.6274 90.6274C84.6263 96.6286 76.4869 100 68 100C59.5131 100 51.3737 96.6286 45.3726 90.6274C39.3714 84.6263 36 76.4869 36 68C36 59.5131 39.3714 51.3737 45.3726 45.3726C51.3737 39.3714 59.5131 36 68 36ZM64.0137 74.3131L56.9051 67.2C56.6503 66.9452 56.3478 66.743 56.0148 66.6051C55.6818 66.4672 55.325 66.3962 54.9646 66.3962C54.6042 66.3962 54.2473 66.4672 53.9143 66.6051C53.5814 66.743 53.2788 66.9452 53.024 67.2C52.5093 67.7147 52.2202 68.4127 52.2202 69.1406C52.2202 69.8684 52.5093 70.5665 53.024 71.0811L62.0754 80.1326C62.3295 80.3887 62.6318 80.592 62.9649 80.7307C63.298 80.8695 63.6552 80.9409 64.016 80.9409C64.3768 80.9409 64.734 80.8695 65.0671 80.7307C65.4002 80.592 65.7025 80.3887 65.9566 80.1326L84.6994 61.3851C84.9577 61.1314 85.1631 60.829 85.3039 60.4954C85.4447 60.1618 85.5181 59.8037 85.5197 59.4416C85.5214 59.0795 85.4514 58.7207 85.3137 58.3858C85.176 58.051 84.9734 57.7467 84.7175 57.4905C84.4617 57.2343 84.1576 57.0313 83.8229 56.8932C83.4882 56.7552 83.1295 56.6847 82.7674 56.686C82.4053 56.6872 82.0471 56.7602 81.7133 56.9006C81.3796 57.041 81.0769 57.2461 80.8229 57.504L64.0137 74.3131Z",
    fill: "#169560"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderplaced);
export default __webpack_public_path__ + "static/media/orderplaced.074ef36551c3c692c7b19d66be7ac39b.svg";
export { ForwardRef as ReactComponent };